import React, { Component, Fragment } from "react";
import classnames from "classnames";
import equal from "fast-deep-equal/es6";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { delay } from "@formant/core/common/delay";
import { fork } from "@formant/core/common/fork";
import { IValidation } from "@formant/core/model/IValidation";
import { animate } from "@formant/ui/utils/animate";

import * as styles from "./ValidationMessages.scss";

export interface IValidationMessagesProps {
    validation?: IValidation;
    className?: string;
    keys?: string[];
}

@observer
export class ValidationMessages extends Component<IValidationMessagesProps> {
    @observable
    private validations: IValidation[] = [];
    @observable
    private visible: boolean = false;

    public render() {
        fork(this.show(this.props.validation));

        const { className, keys } = this.props;

        const validations = this.validations.map((validation, i) => (
            <div
                key={i}
                className={classnames(
                    styles.validation,
                    className,
                    equal(this.props.validation, validation) &&
                        this.visible &&
                        styles.visible,
                )}
            >
                {Object.keys(validation)
                    .filter(
                        field =>
                            validation[field] &&
                            (keys === undefined ||
                                keys.some(
                                    _ =>
                                        field === _ ||
                                        field.startsWith(`${_}.`),
                                )),
                    )
                    .map(field => (
                        <div key={field} className={styles.field}>
                            <div
                                data-testid={`validation-message-${field}`}
                                className={styles.messages}
                            >
                                {validation[field].map((_, j) => (
                                    <Fragment key={j}>
                                        {_}
                                        <br />
                                    </Fragment>
                                ))}
                            </div>
                        </div>
                    ))}
            </div>
        ));

        return (
            <div className={styles["validation-messages"]}>{validations}</div>
        );
    }

    private async show(validation?: IValidation) {
        await delay();
        if (this.validations.find(_ => equal(_, validation)) !== undefined) {
            return;
        }
        if (validation) {
            this.visible = false;
            this.validations.push(validation);
            await animate();
            this.visible = true;
            await animate();
        }
    }
}
